import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import MainLayout from '../../layouts/MainLayout';
import './styles/EBooks.css';
import './styles/bookListComponent.css';

const ReaderThink5WhysMainBook = () => {
  const [pageContent, setPageContent] = useState('');

  useEffect(() => {
    const fetchPageContent = async () => {
      try {
        const response = await axios.get('/api/think5whysbookmain/content/T');
        setPageContent(response.data.pageContent);
      } catch (error) {
        console.error('Error fetching page content:', error);
      }
    };

    fetchPageContent();
  }, []);

  return (
    <MainLayout>
      <div>
        <h3 className='text-lg mt-1 mx-8 border-b border-b-gray-300 text-white'>Book Reading</h3>
      </div>
      <div className='bookread-page-container'>
        {loading ? (
          <p className="loading">Loading...</p>
        ) : (
          <div>
          <div dangerouslySetInnerHTML={{ __html: pageContent }} />
          </div>
        )}
      </div>
    </MainLayout>
  );
};

export default ReaderThink5WhysMainBook;


